import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import { Container } from '../../modules/components';


export default function ManagementsRouter() {

    /*Rotas para Usuários*/
    const DatatableUsers = lazy(() => import('../../pages/users/DatatableUsers'));
    const ShowUser = lazy(() => import('../../pages/users/ShowUser'));

    const DatatablePrivileges = lazy(() => import('../../pages/privileges/DatatablePrivileges'));
    const ShowPrivilege = lazy(() => import('../../pages/privileges/ShowPrivilege'));

    return (
        <Container loading={false}>
            <Switch>
                <Route
                    path='/gestao/usuarios/:cpf'
                component={ShowUser}
                />
                <Route
                path='/gestao/usuarios'
                component={ DatatableUsers }
                />
                <Route
                    path='/gestao/perfis/:id'
                    component={ShowPrivilege}
                />
                <Route
                    path='/gestao/perfis'
                    component={DatatablePrivileges}
                />
            </Switch>
        </Container>
    )
}
